var actionTypes = require('../../../actionTypes.js');

module.exports.createAction = (payload)=> (
            {
                type: actionTypes.modalSpinnerUI,
                payload: payload
            }
           )

module.exports.changeState = (previousState, payload)=> Object.assign({}, previousState, {modalSpinnerDialogue: payload})